import makePlainAction from '../../../../creators/actions/makePlainAction';
/**
 * Plain action that updates an existing set of pending data.
 *
 * @public
 * @author Connor Taylor
 *
 * @example
 * dispatch(updatePendingData({
 *   id: `foobar`,
 *   changes: { foo: `bar` },
 * }));
 */

var updatePendingData = makePlainAction({
  model: "pending_data",
  verb: "update"
});
/** @component */

export default updatePendingData;